window.$ = window.jQuery = require('jquery');

require('bootstrap');

//require('bootstrap/js/dist/util');
//require('bootstrap/js/dist/collapse');

require('@fancyapps/fancybox');
// require('@fancyapps/fancybox/dist/jquery.fancybox.css');
require('./_fancybox.js');

require('lazysizes/plugins/respimg/ls.respimg');
require('lazysizes/plugins/bgset/ls.bgset');
require('lazysizes');

require('./_navbar-fixed.js');

require('slick-carousel');
require('./_slick-carousel.js');

require('./_smoothscroll.js');

require('./_console.js');
